angular.module('impactx.search').controller('LotSearchListCtrl', [
    'SearchFilter',
    LotSearchListCtrl
]);

function LotSearchListCtrl(SearchFilter) {
    var self = this;
    self.nameSort = 0;
    SearchFilter.resetSort();

    self.sortByName = function () {
        self.nameSort = SearchFilter.sortByName(false);
        search();
    };

    function search() {
        self.containerCtrl.updateContent(1, SearchFilter.getSelectedSort(self.nameSort));
    }
}
